import { createContext, useContext, useEffect, useState } from 'react';
import { getMe, login as apiLogin, logout as apiLogout } from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // null = verificando sessão, false = não autenticado, objeto = autenticado
  const [user, setUser] = useState(null);

  useEffect(() => {
    getMe()
      .then(setUser)
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const loggedUser = await apiLogin(email, password);
    setUser(loggedUser);
    return loggedUser;
  };

  const logout = async () => {
    try {
      await apiLogout();
    } finally {
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
